import React, { useEffect, useState } from 'react';
import api from '../axios';
import { Link } from 'react-router-dom';

const Anasayfa = () => {
    const [softwares, setSoftwares] = useState([]);
    const [loading, setLoading] = useState(true);
    const [isMenuOpen, setIsMenuOpen] = useState(false);
    useEffect(() => {
      const fetchSoftwares = async () => {
        try {
          const res = await api.get('/api/software');
          setSoftwares(res.data);
        } catch (error) {
          console.error('Yazılımlar alınamadı:', error);
        } finally {
          setLoading(false);
        }
      };
  
      fetchSoftwares();
    }, []);
  return (
    <div className="min-h-screen bg-gray-50 text-gray-800">
      {/* HEADER */}
      <header className="bg-white shadow-md fixed top-0 left-0 w-full z-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 py-4 flex justify-between items-center">
        {/* Logo */}
        <h1 className="text-xl sm:text-2xl font-bold text-blue-600">SERCHUVA SOFTWARE</h1>

        {/* Desktop Menü */}
        <nav className="hidden md:flex items-center space-x-4">
          <a href="#hakkimizda" className="text-gray-600 hover:text-blue-500">Hakkımızda</a>
          <a href="#yazilimlar" className="text-gray-600 hover:text-blue-500">Yazılımlar</a>
          <a href="#yorumlar" className="text-gray-600 hover:text-blue-500">Yorumlar</a>
          <a href="#iletisim" className="text-gray-600 hover:text-blue-500">İletişim</a>
          <Link
            to="/login"
            className="bg-blue-500 hover:bg-blue-600 text-white font-semibold px-4 py-2 rounded transition"
          >
            Giriş Yap
          </Link>
        </nav>

        {/* Mobil Menü Toggle */}
        <button
          onClick={() => setIsMenuOpen(!isMenuOpen)}
          className="md:hidden focus:outline-none text-gray-600"
        >
          <svg className="w-6 h-6" fill="none" stroke="currentColor" strokeWidth="2"
               viewBox="0 0 24 24">
            <path
              strokeLinecap="round" strokeLinejoin="round"
              d={isMenuOpen ? "M6 18L18 6M6 6l12 12" : "M4 6h16M4 12h16M4 18h16"}
            />
          </svg>
        </button>
      </div>

      {/* Mobil Menü */}
      {isMenuOpen && (
        <div className="md:hidden bg-white border-t border-gray-200 px-4 py-3 space-y-2">
          <a href="#hakkimizda" className="block text-gray-700 hover:text-blue-500">Hakkımızda</a>
          <a href="#yazilimlar" className="block text-gray-700 hover:text-blue-500">Yazılımlar</a>
          <a href="#yorumlar" className="block text-gray-700 hover:text-blue-500">Yorumlar</a>
          <a href="#iletisim" className="block text-gray-700 hover:text-blue-500">İletişim</a>
          <Link
            to="/login"
            className="inline-block bg-blue-500 hover:bg-blue-600 text-white font-semibold px-4 py-2 rounded w-full text-center"
          >
            Giriş Yap
          </Link>
        </div>
      )}
    </header>

      {/* SLIDER */}
      <section className="w-full min-h-[60vh] md:h-screen bg-gradient-to-b from-[#0a2540] to-[#001628] text-white flex items-center">
  <div className="max-w-7xl mx-auto px-4 md:px-6 grid grid-cols-1 md:grid-cols-2 gap-10 items-center">
    {/* SOL METİN */}
    <div>
      <h1 className="text-3xl sm:text-4xl md:text-5xl font-bold mb-6 leading-tight text-center md:text-left">
        İş Süreçlerinizi Dijitalleştirin, Geleceğe Hazır Hale Getirin
      </h1>
      <p className="text-md sm:text-lg text-gray-300 mb-6 text-center md:text-left">
        Geliştirdiğimiz yazılımlar sayesinde işletmenize özel çözümler sunuyoruz.
      </p>
      <div className="flex flex-wrap justify-center md:justify-start gap-4">
        <button className="bg-white text-[#0a2540] font-semibold px-5 py-3 rounded hover:bg-gray-100">
          Çözümlerimizi Keşfedin
        </button>
        <button className="bg-gray-700 text-white px-5 py-3 rounded hover:bg-gray-600">
          Demo Talep Edin
        </button>
      </div>
    </div>

    {/* SAĞ GÖRSEL */}
    <div className="hidden md:flex justify-center">
      <img
        src="/images/slider-image.png"
        alt="SerchuVa-Slider"
        className="w-full max-w-lg"
      />
    </div>
  </div>
</section>

    <section id="hakkimizda" className="py-20 bg-white">
  <div className="max-w-7xl mx-auto px-6 grid md:grid-cols-2 gap-10 items-center">
    {/* METİN */}
    <div>
      <h2 className="text-3xl font-bold text-gray-800 mb-4">Biz Kimiz?</h2>
      <p className="text-gray-600 text-lg mb-4">
        FABRISMART, üretimden yönetime kadar iş süreçlerini dijitalleştiren yenilikçi yazılımlar geliştiren bir teknoloji girişimidir. 
        C# tabanlı çözümlerimiz ile işletmelere esneklik, hız ve güvenlik kazandırıyoruz.
      </p>
      <p className="text-gray-600 text-lg">
        Müşteri odaklı yaklaşımımızla, sektöre özel özelleştirilebilir yapılar sunuyor; destek ve sürdürülebilirlik konularında fark yaratıyoruz.
      </p>
    </div>

    {/* GÖRSEL */}
    <div className="flex justify-center">
      <img
        src="/images/bizkimiz.jpg"
        alt="FABRISMART Ekibi"
        className="rounded-xl shadow-lg w-full max-w-md"
      />
    </div>
  </div>
</section>
{/* YAZILIMLAR */}
<section id="yazilimlar" className="py-16 bg-gray-100">
      <div className="max-w-6xl mx-auto px-4">
        <h2 className="text-3xl font-bold text-center mb-10">Yazılımlarımız</h2>

        {loading ? (
          <p className="text-center text-gray-500">Yükleniyor...</p>
        ) : (
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
            {softwares.filter((item) => item.anaEkrandaGoster === true)
            .map((item) => (
              <div key={item.id} className="bg-white rounded-xl shadow hover:shadow-lg transition p-4 flex flex-col">
              {/* Görsel */}
              {item.imageUrl && (
                <img
                  src={item.imageUrl}
                  alt={item.name}
                  className="w-full h-48 object-cover rounded-t-md mb-4"
                />
              )}
            
              {/* Başlık ve Açıklama */}
              <h3 className="text-xl font-semibold text-gray-800 mb-2">{item.name}</h3>
              <p className="text-gray-600 flex-grow">{item.description}</p>
            
              {/* Buton */}
              {/*<div className="mt-4 text-right">
                <Link
                  to={`/yazilimdetay?id=${item.id}`}
                  className="inline-block bg-blue-500 text-white text-sm px-4 py-2 rounded hover:bg-blue-600"
                >
                  Detay
                </Link>
              </div>*/}
            </div>
            ))}
          </div>
        )}
      </div>
    </section>

      {/* REFERANSLAR ve MÜŞTERİ YORUMLARI */}
      {/*<section id="yorumlar" className="py-16 bg-white">
        <div className="max-w-6xl mx-auto px-4 text-center">
          <h2 className="text-3xl font-bold mb-10">Müşteri Yorumları</h2>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
            <div className="bg-gray-100 p-6 rounded shadow">
              <p className="italic text-gray-700 mb-2">
                "FABRISMART sayesinde lisans sistemimizi tamamen kontrol altına aldık!"
              </p>
              <span className="block font-semibold">— Ahmet D.</span>
            </div>
            <div className="bg-gray-100 p-6 rounded shadow">
              <p className="italic text-gray-700 mb-2">
                "Kullandığımız stok takip yazılımı harika, destekleri de çok hızlı."
              </p>
              <span className="block font-semibold">— Merve T.</span>
            </div>
            <div className="bg-gray-100 p-6 rounded shadow">
              <p className="italic text-gray-700 mb-2">
                "Panel arayüzleri çok kullanıcı dostu. Memnunuz."
              </p>
              <span className="block font-semibold">— Cem K.</span>
            </div>
          </div>
        </div>
      </section>*/}

      {/* FOOTER */}
      <footer id="iletisim" className="bg-gray-800 text-white py-8">
        <div className="max-w-6xl mx-auto px-4 flex flex-col md:flex-row justify-between items-center">
          <p className="mb-4 md:mb-0">© {new Date().getFullYear()} SerchuVa Software. Tüm hakları saklıdır.</p>
          <div className="space-x-4">
            <a href="mailto:admin@serchuvasoftware.com" className="hover:underline">admin@serchuvasoftware.com</a>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default Anasayfa;
